module.exports = __webpack_public_path__ + "static/media/054.2ce04142.jpg";